<script context="module">
  // context="module" makes this exportable
  export const DEFAULT_WIDTH = 240;
</script>

<script>
  import { getAccessibilityRedesignRenderState } from '../../../../../js/stores';
  // Props
  export let alignment = 'left';
  export let isOpen = false;
  export let width = DEFAULT_WIDTH;

  const accessibilityRedesignRenderStore = getAccessibilityRedesignRenderState();
</script>

<!-- 
  NOTE:
  To ensure that the flyout is visibily hidden until the css is ready, 
  we use --flyout-visibility variable with hidden as default to toggle visibility
-->
<div
  class="Flyout align-{alignment}"
  class:isOpen
  class:flyout-animation={!$accessibilityRedesignRenderStore}
  class:flyout-accessibility-redesign={$accessibilityRedesignRenderStore}
  style="width: {width}px; visibility: var(--flyout-visibility, hidden);"
>
  <slot />
</div>

<style>.Flyout {
  border-width: 0;
  border-style: solid;
  color: var(--color-text, #1a1a1a);
  background-color: var(--color-background, #fff);
  border-color: var(--color-border, #d9d9d9);
  box-sizing: border-box;
  position: absolute;
  overflow: hidden;
  left: -11px;
  top: 100%;
  border-radius: 4px;
  border-width: 1px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.16);
  --flyout-visibility: hidden;
  opacity: 0;
  pointer-events: none;
  transform: translate3d(0, -10px, 0);
}

.flyout-animation {
  transition: visibility 0ms 100ms, pointer-events 0ms, opacity 100ms cubic-bezier(0.4, 0, 1, 1), transform 100ms cubic-bezier(0.4, 0, 1, 1), width 250ms cubic-bezier(0.4, 0, 0.2, 1);
}
.flyout-animation.isOpen {
  transition: visibility 0ms, pointer-events 0ms 150ms, opacity 150ms cubic-bezier(0, 0, 0.2, 1), transform 150ms cubic-bezier(0, 0, 0.2, 1), width 250ms cubic-bezier(0.4, 0, 0.2, 1);
}

.flyout-accessibility-redesign {
  box-shadow: none;
  border-radius: 0;
  left: 10px;
}

.isOpen {
  --flyout-visibility: visible;
  opacity: 1;
  pointer-events: auto;
  transform: translate3d(0, 0, 0);
}

.align-right {
  left: auto;
  right: 0;
}</style>
